function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  ).filter((element) => {
    if (element.closest('[hidden], [inert], [aria-hidden="true"]')) return false;

    const tabindex = element.getAttribute('tabindex');
    return tabindex === null || !tabindex.startsWith('-');
  });
}

function getCartIconBubbleElements() {
  return Array.from(new Set(Array.from(document.querySelectorAll('#cart-icon-bubble, [data-cart-icon-bubble]'))));
}

function renderCartIconBubbleHTML(html, selector = '.shopify-section') {
  const sourceElement = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  if (!sourceElement) return;

  getCartIconBubbleElements().forEach((element) => {
    element.innerHTML = sourceElement.innerHTML;
  });
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

window.onload = () => {
  // Video
  const videoContainers = document.querySelectorAll('.video-container');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        const videoElement = entry.target.querySelector('video');
        videoElement.pause();
      } else {
        const videoElement = entry.target.querySelector('video');
        videoElement.play();
      }
    });
  });

  videoContainers.forEach((videoContainer) => {
    observer.observe(videoContainer);
  });

  videoContainers.forEach(function (videoContainer) {
    const playButton = videoContainer.querySelector('.play-button');
    const mask = videoContainer.querySelector('.video-mask');
    const video = videoContainer.querySelector('.video-element');

    video.controls = false;

    playButton.addEventListener('click', function () {
      if (video.paused || video.ended) {
        video.play();
      } else {
        video.pause();
      }
    });

    video.addEventListener('play', function () {
      mask.classList.add('hidden');
      playButton.classList.add('hidden');
      video.controls = true;
    });

    video.addEventListener('pause', function () {
      mask.classList.remove('hidden');
      playButton.classList.remove('hidden');
      video.controls = false;
    });

    video.addEventListener('ended', function () {
      mask.classList.remove('hidden');
      playButton.classList.remove('hidden');
      video.controls = false;
    });

    // playVideoOnModalOpen(videoContainer);

    // pauseVideoOnModalClose(videoContainer);
  });

  // Reviews Collection
  const btn = document.getElementById('showMoreButton');
  const reviews = Array.from(document.querySelectorAll('#reviewsContainer .extra-review.hidden'));
  let count = 0,
    allShown = false;

  btn && btn.addEventListener('click', () => {
    if (allShown) reviews.forEach((r) => r.classList.add('hidden')) || (count = allShown = 0);
    else reviews.slice(count, (count += 3)).forEach((r) => r.classList.remove('hidden'));
    btn.textContent = (allShown = count >= reviews.length) ? 'Show less' : 'Show more';
  });

  // Mobile Menu
  if (document.getElementById('drawer-navigation')) {
    document.querySelector('[data-drawer-toggle="drawer-navigation"]').addEventListener('click', (event) => {
      const isOpen = event.currentTarget.getAttribute('data-drawer-open') === 'true';
      event.currentTarget.setAttribute('data-drawer-open', !isOpen);
    });
  }
  // });
};

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-section').forEach(function (section) {
    section.querySelectorAll('.productVariantSelect').forEach(function (selectElement) {

      handleChangeEvent(selectElement);

      selectElement.addEventListener('change', function () {
        handleChangeEvent(selectElement);
      });
    });

    function handleChangeEvent(selectElement) {
      const productContainer = selectElement.closest('.container');

      const jsonDataElement = productContainer.querySelector('.product-variants-data');
      if (!jsonDataElement) return;

      const variantsData = JSON.parse(jsonDataElement.textContent);
      const selectedVariantId = parseInt(selectElement.value, 10);
      const selectedVariant = variantsData.find(v => v.id === selectedVariantId);

      if (!selectedVariant) return;

      // Update price
      const priceDisplay = productContainer.querySelector('.productPrice');
      if (priceDisplay) {
        priceDisplay.textContent = '$' + (selectedVariant.price / 100).toFixed(2);
      }

      // Update image if the variant has an associated image
      const imageDisplay = productContainer.querySelector('.productImage img');
      if (imageDisplay && selectedVariant.featured_image && selectedVariant.featured_image.src) {
        imageDisplay.src = 'https:' + selectedVariant.featured_image.src;
        imageDisplay.alt = selectedVariant.title || 'Product image';
      }

      // Update data-variant-id on the add to cart button
      const addToCartButton = productContainer.querySelector('.add-to-cart-btn');
      if (addToCartButton) {
        addToCartButton.setAttribute('data-variant-id', selectedVariant.id);
        if (typeof updateButtonRulesFromVariantId === 'function') {
          updateButtonRulesFromVariantId(addToCartButton, selectedVariant.id);
        }
      }
    }
  });
});

function handleAddToCart(event) {
  if (event.target.classList.contains('btn-disabled')) return;
  event.preventDefault();
  let button = event.target;

  if (!button.hasAttribute('data-variant-id')) {
    button = button.closest('.add-to-cart-btn');
  }

  if (!button) {
    return;
  }

  addToCartFromButton(button);
}

function addToCartFromButton(button) {
  let variantId = button.getAttribute('data-variant-id');
  let quantity = parseInt(button.getAttribute('data-quantity')) || 1;
  let sellingPlan = button.getAttribute('data-selling-plan');
  let redirectToCheckout = button.getAttribute('data-redirect-to-checkout') === 'true';

  // Check if the gift option is checked
  const giftOptionCheckbox = document.getElementById('gift-option');
  const isGift = giftOptionCheckbox && giftOptionCheckbox.checked;

  if (isGift) {
    sellingPlan = null;
  }
  addItemToCart(variantId, quantity, sellingPlan, redirectToCheckout, isGift);
}

function addItemToCart(variantId, quantity, sellingPlan, redirectToCheckout, isGift) {
  let addToCartData = {
    items: [{
      id: variantId,
      quantity: quantity,
      ...(sellingPlan && !isGift && { selling_plan: sellingPlan }),
      properties: {
        ...(isGift && { 'This is a gift': 'Yes' })
      }
    }]
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(addToCartData)
  })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          throw new Error(err.description || 'Network response was not ok');
        });
      }
      return response.json();
    })
    .then(data => {
      // Fetch updated cart to get accurate item count
      return fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          // Publish cart update event for other components
          if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'add-to-cart', cartData: cart });
          }

          // Announce to live region
          if (typeof updateCartAccessibility === 'function') {
            const itemText = cart.item_count === 1 ? 'item' : 'items';
            const message = `Added to cart. Cart now has ${cart.item_count} ${itemText}.`;
            updateCartAccessibility(cart, message);
          }

          if (redirectToCheckout) {
            window.location.href = '/checkout';
          } else {
            window.location.href = '/cart';
          }
        });
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

function updateCartAccessibility(cart, message) {
  const liveRegion = document.getElementById('cart-live-region');

  document.querySelectorAll('[aria-label^="Cart"]').forEach(cartLink => {
    const itemText = cart.item_count === 1 ? 'item' : 'items';
    cartLink.setAttribute('aria-label', `Cart, ${cart.item_count} ${itemText}`);

    const badge = cartLink.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    if (badge) {
      badge.textContent = cart.item_count > 0 && cart.item_count < 100 ? cart.item_count : '';
    }
  });

  if (liveRegion && message) {
    liveRegion.textContent = message;
  }
}

document.querySelectorAll('.add-to-cart-btn').forEach(button => {
  button.addEventListener('click', event => handleAddToCart(event));
});

function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCount = cart.item_count;
      document.getElementById('cart-count').innerText = cartCount;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

// Get query string parameters
function getQueryStringParameters() {
  const queryParams = new URLSearchParams(window.location.search);
  const params = {};
  for (const [key, value] of queryParams) {
    params[key] = value;
  }
  return params;
}

document.addEventListener('DOMContentLoaded', () => {
  toggleProductVisibility();
  waitForGtagAndTrackProducts();
  populateFormFieldsFromQueryParams();
  // handleHubSpotFormSubmissions();

  // Subscribe to cart updates for accessibility
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event && event.cartData && typeof updateCartAccessibility === 'function') {
        const cartData = event.cartData;
        const itemText = cartData.item_count === 1 ? 'item' : 'items';
        const message = `Cart updated. Cart now has ${cartData.item_count} ${itemText}.`;
        updateCartAccessibility(cartData, message);
      }
    });
  }

  // Initialize cart accessibility on page load
  if (typeof updateCartAccessibility === 'function') {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        updateCartAccessibility(cart);
      })
      .catch(() => {
        // Silently fail if cart can't be fetched
      });
  }
});

function toggleProductVisibility() {
  const params = getQueryStringParameters();
  if (params.easyconnect === 'true') {
    toggleClass('.easy-connect-product', 'hidden', false);
    toggleClass('.threaded-product', 'hidden', true);
  }
}

function toggleClass(selector, className, shouldAdd) {
  document.querySelectorAll(selector).forEach(element => {
    element.classList.toggle(className, shouldAdd);
  });
}

function waitForGtagAndTrackProducts() {
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach(mutation => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(node => {
          if (node.tagName === 'SCRIPT' && node.src.includes('gtag/js?id=G-')) {
            trackProductViewEvents();
            observer.disconnect();
          }
        });
      }
    });
  });

  observer.observe(document.head, { childList: true });
}

function trackProductViewEvents() {
  document.querySelectorAll('.product-section:not(.hidden)').forEach(section => {
    const addToCartButton = section.querySelector('.add-to-cart-btn');
    const gaItems = JSON.parse(addToCartButton.dataset.gaItems);
    gtag('event', 'view_item', {
      currency: "USD",
      value: gaItems[0].price,
      items: gaItems
    });
  });
}

function populateFormFieldsFromQueryParams() {
  const hubspotForm = document.querySelector('form[data-hubspot]');
  if (hubspotForm) {
    const params = getQueryStringParameters();
    Object.entries(params).forEach(([key, value]) => {
      const field = hubspotForm.querySelector(`input[name="${key}"]`);
      if (field) field.value = value;
    });
  }
}

function handleHubSpotFormSubmissions() {
  document.querySelectorAll('form[data-hubspot]').forEach(form => {
    form.addEventListener('submit', event => submitHubSpotForm(event, form));
  });
}

async function submitHubSpotForm(event, form) {
  event.preventDefault();
  clearErrorMessages(form);

  if (!validateEmailAndDomain(form)) return;

  const shouldSubmit = preprocessAndCheckSubmission(form);
  if (!shouldSubmit) return;

  const submissionResult = await attemptFormSubmission(form);
  postprocessSubmission(form, submissionResult);
}

// Process all HubSpot form submissions
const forms = document.querySelectorAll('form[data-hubspot]');
forms.forEach(form => {
  form.addEventListener('submit', async event => {
    event.preventDefault();

    // Delete any error messages
    const errorMessages = document.querySelectorAll(`.form-${form.dataset.formGuid}-alert.error-message`);
    errorMessages.forEach(message => message.remove());

    // Validate email field
    const emailField = form.querySelector('input.email_field');
    if (emailField && !isValidEmail(emailField.value)) {
      showAlert(form, 'Please enter a valid email address (Ex: johndoe@domain.com).', 'error', form.dataset.timeoutDuration);
      return;
    }

    // Reject free email addresses
    const blockFreeEmailDomains = form.dataset.blockFreeEmailDomains;
    if (blockFreeEmailDomains === 'true' && !rejectFreeEmails(emailField.value)) {
      showAlert(form, 'Please use your business email address.', 'error', form.dataset.timeoutDuration);
      return;
    }

    const preprocessFunctionName = form.dataset.preprocessFunction;
    if (preprocessFunctionName && window[preprocessFunctionName]) {
      const shouldSubmit = window[preprocessFunctionName](form);
      if (!shouldSubmit) return;
    }

    let submissionResult = false;  // Declare submissionResult in a broader scope

    const submissionData = collectAndFormatData(form);
    const portalId = 7271814; // form.dataset.portalId;
    const formGuid = form.dataset.formGuid;

    if (portalId && formGuid) {
      submissionResult = await submitToHubSpot(portalId, formGuid, submissionData);

      if (submissionResult) {
        const successMessage = form.dataset.successMessage || 'Form submitted successfully!';
        showAlert(form, successMessage, 'success', form.dataset.timeoutDuration);

        // Check if data-hide-form-on-success is true and add hidden class
        if (form.dataset.hideFormOnSuccess === 'true') {
          form.classList.add('hidden');
        }
      } else {
        showAlert(form, 'Error submitting form.', 'error', form.dataset.timeoutDuration);
      }
    } else {
      console.error('Missing portalId or formGuid on form', form);
    }

    // Execute post-submission function
    const postprocessFunctionName = form.dataset.postprocessFunction;
    if (postprocessFunctionName && typeof window[postprocessFunctionName] === 'function') {
      window[postprocessFunctionName](form, submissionResult);
    }

  });
});

function collectAndFormatData(form) {
  const fieldGroups = {};

  // Group elements by unique combination of name and objectTypeId
  for (const element of form.elements) {
    if (!element.name) continue;

    const objectTypeId = element.dataset.objectTypeId || "0-1";
    const key = `${element.name}-${objectTypeId}`;

    if (!fieldGroups[key]) {
      fieldGroups[key] = { name: element.name, objectTypeId, values: [] };
    }

    if (element.tagName === 'SELECT') {
      fieldGroups[key].values.push(element.value);
    } else if (element.type !== 'radio' && element.type !== 'checkbox' || element.checked) {
      fieldGroups[key].values.push(element.value);
    }
  }

  const fields = Object.values(fieldGroups).map(group => ({
    name: group.name,
    objectTypeId: group.objectTypeId,
    value: group.values.join(', ') // Join values if there are multiple, for checkboxes/radio buttons
  }));

  const context = {
    hutk: getCookieValue('hubspotutk'),
    pageUri: form.dataset.pageUri || window.location.href,
    pageName: form.dataset.pageName || document.title,
  };

  const consentToProcessField = form.querySelector('[name="consentToProcess"]');
  const consentToProcess = consentToProcessField ? consentToProcessField.checked : false;

  const legalConsentOptions = consentToProcess ? {
    consent: {
      consentToProcess,
      text: form.dataset.consentText || "",
      // ... other legal consent options
    }
  } : null;

  const submissionData = {
    submittedAt: new Date().getTime().toString(),
    fields,
    context,
    ...(legalConsentOptions ? { legalConsentOptions } : {}),  // Conditionally include legalConsentOptions
  };

  return submissionData;
}

async function submitToHubSpot(portalId, formGuid, submissionData) {
  const url = `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`;
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(submissionData),
    });

    if (!response.ok) {
      // If the HTTP response is not OK, consider it a failure
      response.text().then(text => {
        throw new Error('Failed to submit form: ' + text);
      });
    }

    const jsonResponse = await response.json();
    return true; // Explicitly return true for success
  } catch (error) {
    console.error('Error submitting form:', error);
    return false; // Explicitly return false for failure
  }
}

function isValidEmail(email) {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
}

// Reject free email addresses
function rejectFreeEmails(email) {
  const freeEmailDomains = [
    'gmail.com',
    'yahoo.com',
    'hotmail.com',
    'aol.com',
    'outlook.com',
    'icloud.com',
    'mail.com',
    'protonmail.com',
    'zoho.com',
    'yandex.com',
    'live.com',
    'gmx.com',
    'inbox.com',
    'fastmail.com',
    'tutanota.com',
    'rocketmail.com',
    'mailinator.com',
    'hushmail.com',
    'cox.net',
    'att.net',
  ];

  if (freeEmailDomains.some(domain => email.includes(domain))) return false;

  return true;
}

// Helper function to get a cookie value by name
function getCookieValue(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

// Function to show alert
function showAlert(form, message, type, timeoutDuration = 3000) {
  const formGuid = form.dataset.formGuid;
  const alertHTML = `
  <div class="container">
    <div class="form-${formGuid}-alert flex gap-2 items-center max-w-2xl mt-4 mx-auto px-2.5 py-2 mb-4 text-sm ${type === 'success' ? 'success-message bg-green-50 text-green-700' : 'error-message bg-red-50 text-red-700'} rounded-lg hidden" role="alert">
      ${type === 'success'
      ? '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.9999 21.5999C14.546 21.5999 16.9878 20.5885 18.7881 18.7881C20.5885 16.9878 21.5999 14.546 21.5999 11.9999C21.5999 9.45382 20.5885 7.01203 18.7881 5.21168C16.9878 3.41133 14.546 2.3999 11.9999 2.3999C9.45382 2.3999 7.01203 3.41133 5.21168 5.21168C3.41133 7.01203 2.3999 9.45382 2.3999 11.9999C2.3999 14.546 3.41133 16.9878 5.21168 18.7881C7.01203 20.5885 9.45382 21.5999 11.9999 21.5999ZM16.4483 10.4483C16.6669 10.222 16.7878 9.91886 16.7851 9.60422C16.7824 9.28959 16.6562 8.98861 16.4337 8.76612C16.2112 8.54363 15.9102 8.41743 15.5956 8.41469C15.2809 8.41196 14.9778 8.53291 14.7515 8.7515L10.7999 12.7031L9.2483 11.1515C9.02198 10.9329 8.71886 10.812 8.40422 10.8147C8.08958 10.8174 7.78861 10.9436 7.56612 11.1661C7.34363 11.3886 7.21743 11.6896 7.21469 12.0042C7.21196 12.3189 7.33291 12.622 7.5515 12.8483L9.9515 15.2483C10.1765 15.4733 10.4817 15.5996 10.7999 15.5996C11.1181 15.5996 11.4233 15.4733 11.6483 15.2483L16.4483 10.4483Z" fill="#21A252"/></svg>'
      : '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M21.5999 11.9999C21.5999 14.546 20.5885 16.9878 18.7881 18.7881C16.9878 20.5885 14.546 21.5999 11.9999 21.5999C9.45382 21.5999 7.01203 20.5885 5.21168 18.7881C3.41133 16.9878 2.3999 14.546 2.3999 11.9999C2.3999 9.45382 3.41133 7.01203 5.21168 5.21168C7.01203 3.41133 9.45382 2.3999 11.9999 2.3999C14.546 2.3999 16.9878 3.41133 18.7881 5.21168C20.5885 7.01203 21.5999 9.45382 21.5999 11.9999ZM13.1999 16.7999C13.1999 17.1182 13.0735 17.4234 12.8484 17.6484C12.6234 17.8735 12.3182 17.9999 11.9999 17.9999C11.6816 17.9999 11.3764 17.8735 11.1514 17.6484C10.9263 17.4234 10.7999 17.1182 10.7999 16.7999C10.7999 16.4816 10.9263 16.1764 11.1514 15.9514C11.3764 15.7263 11.6816 15.5999 11.9999 15.5999C12.3182 15.5999 12.6234 15.7263 12.8484 15.9514C13.0735 16.1764 13.1999 16.4816 13.1999 16.7999ZM11.9999 5.9999C11.6816 5.9999 11.3764 6.12633 11.1514 6.35137C10.9263 6.57642 10.7999 6.88164 10.7999 7.1999V11.9999C10.7999 12.3182 10.9263 12.6234 11.1514 12.8484C11.3764 13.0735 11.6816 13.1999 11.9999 13.1999C12.3182 13.1999 12.6234 13.0735 12.8484 12.8484C13.0735 12.6234 13.1999 12.3182 13.1999 11.9999V7.1999C13.1999 6.88164 13.0735 6.57642 12.8484 6.35137C12.6234 6.12633 12.3182 5.9999 11.9999 5.9999Z" fill="#C81E1E"/></svg>'
    }
      <div>
        ${message}
      </div>
    </div>
    </div>`;

  form.insertAdjacentHTML('afterend', alertHTML);

  const alert = document.querySelector(`.form-${formGuid}-alert.hidden`);

  alert.classList.remove('hidden');

  if (timeoutDuration > 0) {
    setTimeout(() => {
      alert.classList.add('hidden');
      alert.remove();
    }, timeoutDuration);
  }
}

// Popups
window.addEventListener('load', () => {
  const popups = document.querySelectorAll('.popup');

  const setCookie = (name, value, days) => {
    if (days > 0) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      const expires = "expires=" + date.toUTCString();
      document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }
  };

  const getCookie = (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  popups.forEach((popup) => {
    const id = popup.id;
    const popupId = popup.dataset.popupId;
    const enableImmediate = popup.dataset.showImmediately === 'true';
    const timeDelay = parseInt(popup.dataset.timeDelay, 10);
    const scrollPercentage = parseInt(popup.dataset.scrollPercentage, 10);
    const cookieExpiry = parseInt(popup.dataset.cookieExpiry, 10);
    const modal = FlowbiteInstances.getInstance('Modal', popup.id);

    const modalTrigger = document.querySelector(`[data-modal-target="${id}"]`);
    // if (modalTrigger && getCookie(`${popupId}-trigger`) !== 'hidden') {
    if (modalTrigger) {
      modalTrigger.addEventListener('click', () => {
        setCookie(popupId, 'shown', cookieExpiry);
      });

      modalTrigger.classList.remove('hidden');
      const svg = modalTrigger.querySelector('svg');
      svg.addEventListener('click', (event) => {
        event.stopPropagation();
        modalTrigger.classList.add('hidden');
        // setCookie(`${popupId}-trigger`, 'hidden', cookieExpiry);
      });
    }

    const showPopup = () => {
      if (!getCookie(popupId)) {
        modal.show();
        setCookie(popupId, 'shown', cookieExpiry);
      }
    };

    if (enableImmediate) {
      showPopup();
    }

    if (!isNaN(timeDelay) && timeDelay > 0) {
      setTimeout(showPopup, timeDelay * 1000);
    }

    if (!isNaN(scrollPercentage) && scrollPercentage > 0) {
      window.addEventListener('scroll', () => {
        const scrolledPercentage = (window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100;
        if (scrolledPercentage >= scrollPercentage) {
          showPopup();
        }
      });
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-ga-category]').forEach(element => {
    if (element.tagName === 'SELECT') {
      element.addEventListener('change', trackEvent);
    } else {
      element.addEventListener('click', trackEvent);
    }
  });

  function trackEvent(event) {
    const category = event.target.dataset.gaCategory;
    const action = event.target.dataset.gaAction;
    let label = '';

    if (event.target.tagName === 'SELECT') {
      label = event.target.options[event.target.selectedIndex].text;
    } else {
      label = event.target.dataset.gaLabel || event.target.innerText.trim();
    }

    const eventData = {
      'event_category': category,
      'event_label': label
    };

    if (action === 'add_to_cart') {
      eventData['currency'] = event.target.dataset.gaCurrency;
      eventData['value'] = parseFloat(event.target.dataset.gaValue);

      if (event.target.dataset.gaItems) {
        eventData['items'] = JSON.parse(event.target.dataset.gaItems);
      }
    }

    sendToGoogleAnalytics(action, eventData);
  }

  function sendToGoogleAnalytics(action, eventData) {
    gtag('event', action, eventData);
  }
});

// Fix Lighthouse accessibility issue with HubSpot chat iframe
window.hsConversationsOnReady = [
  () => {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.id === 'hubspot-messages-iframe-container') {
              const iframe = node.querySelector('#hubspot-conversations-iframe');
              if (iframe) {
                iframe.setAttribute('role', 'application');
                observer.disconnect();
              }
              node.classList.add('print:hidden');
            }
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  },
];

window.addEventListener("load", function () {
  const forms = document.querySelectorAll('[data-product-form]');

  const hideElements = (elements) => elements.forEach(el => el.classList.add('hidden'));
  const showElements = (elements) => elements.forEach(el => el.classList.remove('hidden'));
  const resetButton = (button) => {
    button.setAttribute('data-variant-id', '');
    button.setAttribute('data-sku', '');
    button.setAttribute('data-selling-plan', '');
    button.textContent = 'Add to cart';
    button.classList.add('btn-disabled');
  };

  const updateTotalPrice = (form, addToCartButton) => {
    const selectedProduct = form.querySelector('input[name="product"]:checked');
    const selectedVariant = form.querySelector('input[name^="variant-selection"]:checked');

    if (selectedProduct && selectedVariant) {
      const quantityInput = form.querySelector('[data-input-counter]');
      const variantPrice = parseFloat(selectedVariant.getAttribute('data-variant-price'));
      let totalPrice = variantPrice;

      if (quantityInput) {
        const quantity = quantityInput.value;
        addToCartButton.setAttribute('data-quantity', quantity);
        totalPrice *= quantity;
      }

      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      });

      const productPrice = form.querySelector('[data-product-price]');
      if (productPrice) productPrice.textContent = formatter.format(totalPrice);
      addToCartButton.textContent = `Add to cart - ${formatter.format(totalPrice)}`;
      addToCartButton.classList.remove('btn-disabled');
    }
  };

  forms.forEach(function (form) {
    const addToCartButton = form.querySelector('.add-to-cart-btn');
    const inputCounter = form.querySelector('[data-input-counter]');

    form.addEventListener('input', function (event) {
      const { name, value, id, dataset } = event.target;

      if (name === 'product') {
        const selectedProductValue = value;
        hideElements(document.querySelectorAll('swiper-slide.default, .product_images:not([data-product-id="' + selectedProductValue + '"])'));
        showElements(document.querySelectorAll('.product_images[data-product-id="' + selectedProductValue + '"]'));

        hideElements(form.querySelectorAll(`[data-variants-for-product]:not([data-variants-for-product="${value}"])`));
        showElements(form.querySelectorAll(`[data-variants-for-product="${value}"]`));

        form.querySelectorAll('input[name^="variant-selection"]').forEach(radio => radio.checked = false);
        resetButton(addToCartButton);

        // Setting variant attributes if present
        if (dataset.variantId && dataset.variantPrice) {
          addToCartButton.setAttribute('data-variant-id', dataset.variantId);
          addToCartButton.setAttribute('data-sku', dataset.sku || '');
          addToCartButton.setAttribute('data-selling-plan', dataset.variantSellingPlanGroupId || '');
          addToCartButton.classList.remove('btn-disabled');
          if (typeof updateButtonRulesFromVariantId === 'function') {
            updateButtonRulesFromVariantId(addToCartButton, dataset.variantId);
          }
        }
      }

      if (name && name.startsWith('variant-selection')) {
        addToCartButton.setAttribute('data-variant-id', value);
        addToCartButton.setAttribute('data-sku', event.target.getAttribute('data-sku'));
        addToCartButton.setAttribute('data-selling-plan', event.target.getAttribute('data-variant-selling-plan-group-id'));
        if (typeof updateButtonRulesFromVariantId === 'function') {
          updateButtonRulesFromVariantId(addToCartButton, value);
        }
      }

      if (id === 'quantity-input') {
        addToCartButton.setAttribute('data-quantity', value);
      }

      updateTotalPrice(form, addToCartButton);
    });

    if (inputCounter) {
      const inputCounterId = inputCounter.id;
      const inputCounterInstance = FlowbiteInstances.getInstance('InputCounter', inputCounterId);

      const updateQuantity = () => {
        inputCounter.value = inputCounterInstance.getCurrentValue();
        inputCounter.setAttribute('value', inputCounterInstance.getCurrentValue());
        const changeEvent = new Event('input', { bubbles: true });
        inputCounter.dispatchEvent(changeEvent);
      };

      inputCounterInstance._options.onIncrement = updateQuantity;
      inputCounterInstance._options.onDecrement = updateQuantity;
    }

    // Check for pre-selected options on page load
    const selectedProduct = form.querySelector('input[name="product"]:checked');
    const selectedVariant = form.querySelector('input[name^="variant-selection"]:checked');

    if (selectedProduct) {
      const selectedProductValue = selectedProduct.value;
      hideElements(document.querySelectorAll('swiper-slide.default, .product_images:not([data-product-id="' + selectedProductValue + '"])'));
      showElements(document.querySelectorAll('.product_images[data-product-id="' + selectedProductValue + '"]'));

      hideElements(form.querySelectorAll(`[data-variants-for-product]:not([data-variants-for-product="${selectedProductValue}"])`));
      showElements(form.querySelectorAll(`[data-variants-for-product="${selectedProductValue}"]`));

      // Setting variant attributes if present
      const { variantId, variantPrice, variantSellingPlanGroupId, sku } = selectedProduct.dataset;
      if (variantId && variantPrice) {
        addToCartButton.setAttribute('data-variant-id', variantId);
        addToCartButton.setAttribute('data-sku', sku || '');
        addToCartButton.setAttribute('data-selling-plan', variantSellingPlanGroupId || '');
        addToCartButton.classList.remove('btn-disabled');
        if (typeof updateButtonRulesFromVariantId === 'function') {
          updateButtonRulesFromVariantId(addToCartButton, variantId);
        }
      }
    }

    if (selectedVariant) {
      addToCartButton.setAttribute('data-variant-id', selectedVariant.value);
      addToCartButton.setAttribute('data-sku', selectedVariant.getAttribute('data-sku'));
      addToCartButton.setAttribute('data-selling-plan', selectedVariant.getAttribute('data-variant-selling-plan-group-id'));
      if (typeof updateButtonRulesFromVariantId === 'function') {
        updateButtonRulesFromVariantId(addToCartButton, selectedVariant.value);
      }
    }

    updateTotalPrice(form, addToCartButton);

    // Ensure initial SKU is set if button doesn't have one but has a variant ID
    if (!addToCartButton.getAttribute('data-sku') && addToCartButton.getAttribute('data-variant-id')) {
      const variantId = addToCartButton.getAttribute('data-variant-id');
      const matchingVariant = form.querySelector(`input[name^="variant-selection"][value="${variantId}"]`);
      if (matchingVariant) {
        const variantSKU = matchingVariant.getAttribute('data-sku');
        if (variantSKU) {
          addToCartButton.setAttribute('data-sku', variantSKU);
        }
      }
    }
  });
});
